import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { UniHeadingModule, UniMenuModule } from "@universal-ui";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

import { BillingMenuComponent } from "./Components/BillingMenu/billing-menu.component";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { DashboardComponent } from "./dashboard.component";

@NgModule({
  declarations: [DashboardComponent, BillingMenuComponent],
  imports: [CommonModule, DashboardRoutingModule, RouterModule, UniHeadingModule, UniMenuModule, BsDropdownModule.forRoot()],
  exports: [BillingMenuComponent],
})
export class DashboardModule {}
